let utils = require('../../../actions/utils');
let analytics = require('../../../actions/analytics');
let content = require('../../../actions/layout/content');
let layoutGroup = require('../../groups/layout');
let userGroup = require('../../groups/user');
let seo = require('../../../actions/seo');

module.exports = [
    analytics.parseUtmFromQuery,
    ...userGroup.checkAuthCookie([
        ...userGroup.getUser
    ]),
    utils.set('layout', 'main'),
    ...layoutGroup.setMainLayoutBlocks,
    seo.setDashboardMeta('Обучающие видеоуроки - Библиотека данных', 'Обучающие видеоуроки о библиотеке данных'),
    content.setComponentsByLink,
    analytics.pageview
];



// WEBPACK FOOTER //
// ./signals/pages/video/index.js